import { IFieldArray } from "AngularFormly";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../records/forms/formly/fieldConfigurationHelpers";
import fieldHelpers from "../../../../../ui-formly/fieldHelpers";
import {
  ProgressiveDefinition,
  ProgressiveDefinitionGame,
} from "../../../models/progressiveDefinition";
import { ensureEnabledQueryBuilder } from "../../../../../records/forms/formly/types/recordSelectAsync/utils";

export function ProgressivesEditFormFields(
  fieldConfigurationHelperService: FieldConfigurationHelperService
): IFieldArray {
  return [
    ...fieldHelpers.columnLayout(
      [
        fieldHelpers.simpleStringField({
          key: "GameProgramNumber",
          label: "Game Program Number",
          required: true,
        }),
        fieldHelpers.simpleStringField({ key: "Name", required: true }),
      ],
      4
    ),
    fieldConfigurationHelperService.repeaterField({
      key: "Games",
      label: "Games",
      allowAdd: true,
      allowAddBottom: false,
      displayNameSingular: "Game",
      displayNamePlural: "Games",
      showHeader: true,
      repeaterFields: gameFields(fieldConfigurationHelperService),
    }),
    {
      key: "Files",
      name: "Files",
      type: "recordFileUpload",
      templateOptions: {
        label: "Files",
        allowMultiple: true,
      },
    },
  ];
}

function levelFields(
  fieldConfigurationHelperService: FieldConfigurationHelperService
): IFieldArray {
  return [
    ...fieldHelpers.columnLayout(
      [
        fieldHelpers.simpleStringField({
          key: "Name",
          label: "Prize Level",
        }),
        fieldHelpers.simpleCurrencyField({
          key: "MaxJackpot",
          label: "Max Jackpot",
          min: 0,
        }),
        fieldHelpers.simpleCurrencyField({
          key: "ResetValue",
          label: "Reset Value",
          min: 0,
        }),
        fieldHelpers.simplePercentageField({
          key: "Contribution",
          label: "Contribution",
          min: 0,
          max: 100,
        }),
        fieldHelpers.simplePercentageField({
          key: "HiddenContribution",
          label: "Hidden Contribution",
          min: 0,
          max: 100,
        }),
        {
          key: "copyDelete",
          type: "recordRepeaterCopyDelete",
          templateOptions: {
            label: " ",
            allowMove: true,
          },
        },
      ],
      4
    ),
  ];
}

function gameFields(
  fieldConfigurationHelperService: FieldConfigurationHelperService
): IFieldArray {
  return [
    ...fieldHelpers.columnLayout(
      [
        fieldHelpers.simpleStringField({
          key: "PaytableId",
          label: "Paytable ID",
          required: true,
        }),
        fieldHelpers.simpleNumberField({
          key: "MaxCreditBet",
          label: "Max Bet (credits)",
          min: 0,
          step: 1,
        }),
        fieldConfigurationHelperService.selectAsyncField({
          key: "MachineDenominationId",
          name: "MachineDenominationId",
          label: "Denomination",
          getDefaultItem: (item: ProgressiveDefinitionGame) => {
            return {
              Id: item.MachineDenomination?.Id ?? -1,
              Name: item.MachineDenomination?.Name ?? "",
            };
          },
          queryUrl: "/api/machines/MachineDenomination",
        }),
      ],
      4
    ),
    fieldConfigurationHelperService.repeaterField({
      key: "Levels",
      label: "Levels",
      allowAdd: true,
      allowAddBottom: false,
      displayNameSingular: "Level",
      displayNamePlural: "Levels",
      repeaterFields: levelFields(fieldConfigurationHelperService),
      showHeader: true,
    }),
    {
      key: "copyDelete",
      type: "recordRepeaterCopyDelete",
      templateOptions: {
        label: " ",
        allowMove: true,
      },
    },
  ];
}

ProgressivesEditFormFields.$inject = [FieldConfigurationHelperServiceName];
